



















































































































































































































































































import {SfButton, SfIcon, SfLink, SfVideo} from '~/components';
import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'AboutUsDe',
  head:{
    title: 'Austria VIENNA',
    meta: [
      {
        hid: 'description',
        name: 'description',
        content: ''
      }
    ],
  },
  components: {
    SfVideo,
    SfButton,
    SfIcon,
    SfLink,
  },
});
